module.exports = __webpack_public_path__ + "static/img/6.31c1645.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/6.jpg
// module id = H69U
// module chunks = 25